import Website from "../../../index.js";

export {default as TiledGraphic} from "./TiledGraphic.js";
export {default as ScoreDisplay} from "./ScoreDisplay.js";
export {default as LifeDisplay} from "./LifeDisplay.js";
export {default as MovingGraphic} from "./MovingGraphic.js";
export {default as PhysicsGraphics} from "./PhysicsGraphics.js";

export const createLayeredTiledGraphic = function(aObjectName, aGraphicsName, aLayerIndex, aSpeed = true, aAtBottom = true, aYOffset = 0) {
    let texture = Website.game.getTextures(aObjectName, aGraphicsName)[aLayerIndex];

    let newGraphics = new Website.game.gameplay.graphics.TiledGraphic();
    newGraphics.setup(texture, aAtBottom, aYOffset);
    newGraphics.item.speed = aSpeed;

    return newGraphics.item;
}
